/*
 * @Author: Dom
 * @Date: 2022-05-18 18:14:45
 * @LastEditTime: 2022-05-25 16:14:30
 * @LastEditors: Dom
 * @FilePath: \seller-web\src\views\personal-center\component\password\locales\zh-CN.ts
 */
export default {
    'page.personal.center.compontent.oldpassword.tips' : '输入原密码',
    'page.personal.center.compontent.newpassword.tips' : '设置新密码',
    'page.personal.center.compontent.confirmpassword.tips' : '确认新密码',
    'page.personal.center.compontent.psd.btnconfirm' : '确认修改',
    'page.personal.center.compontent.btnctrl' : '取消',
    'page.personal.center.compontent.txtstart' : '密码修改成功，',
    'page.personal.center.compontent.txtend' : '秒后会自动跳转到登陆页面...',
    'page.personal.center.compontent.login' : '登录',
}
